import React from "react";
import Rating from "react-rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CardDiv from "modules/common/card-div/CardDiv";
import { ProgressBar } from "react-bootstrap";
import {Button} from 'antd';
import { DownloadOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash";
import { isDownloadDisabled } from "modules/utilities/utility";

function BuildPlan({ data, planLength }) {
  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex flex-row gap-4">
            <div className="d-flex gap-2">
              <div className="fw-bold">Total Count:</div>
              <div className="fw-bold">{planLength || "0"}</div>
            </div>
            <div className="">Rating of Customer Happy With Traya</div>
          </div>
          <div>
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={() => ExcelDownload(data)}
              disabled={ isDownloadDisabled || isEmpty(data)}
            >
              Download
            </Button>
          </div>
        </div>
      }
      component={
        <div className="mt-n2">
          <div className="d-flex align-items-center gap-3">
            <Rating
              initialRating={5}
              fullSymbol={
                <FontAwesomeIcon icon="star" className="text-warning" />
              }
              emptySymbol={<FontAwesomeIcon icon="star" className="text-300" />}
              readonly
            />
            <div className="w-50">
              <ProgressBar
                animated={true}
                now={(+data?.happy_rate_5 / planLength) * 100}
              />
            </div>
            <div className="fw-bold">{data?.happy_rate_5}</div>
          </div>
          <div className="d-flex align-items-center gap-3">
            <Rating
              initialRating={4}
              fullSymbol={
                <FontAwesomeIcon icon="star" className="text-warning" />
              }
              emptySymbol={<FontAwesomeIcon icon="star" className="text-300" />}
              readonly
            />
            <div className="w-50">
              <ProgressBar
                animated={true}
                now={(+data?.happy_rate_4 / planLength) * 100}
              />
            </div>
            <div className="fw-bold">{data?.happy_rate_4}</div>
          </div>
          <div className="d-flex align-items-center gap-3">
            <Rating
              initialRating={3}
              fullSymbol={
                <FontAwesomeIcon icon="star" className="text-warning" />
              }
              emptySymbol={<FontAwesomeIcon icon="star" className="text-300" />}
              readonly
            />
            <div className="w-50">
              <ProgressBar
                animated={true}
                now={(+data?.happy_rate_3 / planLength) * 100}
              />
            </div>
            <div className="fw-bold">{data?.happy_rate_3}</div>
          </div>
          <div className="d-flex align-items-center gap-3">
            <Rating
              initialRating={2}
              fullSymbol={
                <FontAwesomeIcon icon="star" className="text-warning" />
              }
              emptySymbol={<FontAwesomeIcon icon="star" className="text-300" />}
              readonly
            />
            <div className="w-50">
              <ProgressBar
                animated={true}
                now={(+data?.happy_rate_2 / planLength) * 100}
              />
            </div>
            <div className="fw-bold">{data?.happy_rate_2}</div>
          </div>
          <div className="d-flex align-items-center gap-3">
            <Rating
              initialRating={1}
              fullSymbol={
                <FontAwesomeIcon icon="star" className="text-warning" />
              }
              emptySymbol={<FontAwesomeIcon icon="star" className="text-300" />}
              readonly
            />
            <div className="w-50">
              <ProgressBar
                animated={true}
                now={(+data?.happy_rate_1 / planLength) * 100}
              />
            </div>
            <div className="fw-bold">{data?.happy_rate_1}</div>
          </div>{" "}
        </div>
      }
    />
  );
}

export default BuildPlan;
